export default{
    actividades: [],
    actividadSelec: null,
}